import { BButton } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBButton when migrating. */
export const EgBButton = createEgBootstrapProxy("EgBButton", BButton);
